import moment from 'moment-timezone';

export const unixToDate = epoch => moment.unix(epoch).format('YYYY/MM/DD HH:mm:ss');
